<template>
    <div class="surface-0 border-round-xl p-3 shadow-1">
        <div class="mb-3 flex justify-content-between align-items-center gap-2 flex-wrap">
            <span class="text-lg font-semibold">Значения курса</span>
            <span class="text-sm text-500">Всего {{ totalRecords }}</span>
        </div>

        <DataTable
            :value="values"
            responsiveLayout="scroll"
            lazy
            paginator
            :rows="lazyParams.rows"
            :first="lazyParams.first"
            :rowsPerPageOptions="[10, 20, 50, 100]"
            :totalRecords="totalRecords"
            :loading="loading"
            @page="onPage"
            @sort="onSort"
        >
            <Column field="value" sortable>
                <template #header>
                    <span class="text-xs font-medium">Значение</span>
                </template>
                <template #body="{ data }">
                    <span class="text-sm font-medium">{{ data.value }}</span>
                </template>
            </Column>

            <Column field="from" sortable>
                <template #header>
                    <span class="text-xs font-medium">From</span>
                </template>
                <template #body="{ data }">
                    <span class="text-xs uppercase">{{ data.from }}</span>
                </template>
            </Column>

            <Column field="to" sortable>
                <template #header>
                    <span class="text-xs font-medium">To</span>
                </template>
                <template #body="{ data }">
                    <span class="text-xs uppercase">{{ data.to }}</span>
                </template>
            </Column>

            <Column field="parse_type" sortable>
                <template #header>
                    <span class="text-xs font-medium">Parse type</span>
                </template>
                <template #body="{ data }">
                    <Tag :value="data.parse_type || '-'" severity="info" class="text-xs" />
                </template>
            </Column>

            <Column field="source" sortable>
                <template #header>
                    <span class="text-xs font-medium">Source</span>
                </template>
                <template #body="{ data }">
                    <span class="text-xs">{{ data.source || '-' }}</span>
                </template>
            </Column>

            <Column field="created_at" sortable>
                <template #header>
                    <span class="text-xs font-medium">Создан</span>
                </template>
                <template #body="{ data }">
                    <span class="text-xs">{{ formatDate(data.created_at) }}</span>
                </template>
            </Column>

            <template #empty>
                <div class="py-4 text-center text-sm text-500">Значения не найдены</div>
            </template>
        </DataTable>
    </div>
</template>

<script>
import Helper from '@/assets/js/helper.js'

export default {
    props: {
        values: {
            type: Array,
            default: () => []
        },
        totalRecords: {
            type: Number,
            default: 0
        },
        loading: {
            type: Boolean,
            default: false
        },
        defaultParams: {
            type: Object,
            default: () => ({})
        }
    },
    emits: ['lazyParams'],
    data() {
        return {
            lazyParams: {
                first: this.defaultParams.first ?? 0,
                rows: this.defaultParams.rows ?? 20,
                sortField: this.defaultParams.sortField ?? 'created_at',
                sortOrder: this.defaultParams.sortOrder ?? -1,
                sort: this.defaultParams.sort ?? { field: 'created_at', order: -1 },
            }
        }
    },
    methods: {
        formatDate(value) {
            return this.helper.formatDate(value)
        },
        onPage(event) {
            this.lazyParams.first = event.first
            this.lazyParams.rows = event.rows
            this.$emit('lazyParams', { ...this.lazyParams })
        },
        onSort(event) {
            this.lazyParams.sortField = event.sortField
            this.lazyParams.sortOrder = event.sortOrder
            this.lazyParams.sort = event.sortField ? { field: event.sortField, order: event.sortOrder } : {}
            this.$emit('lazyParams', { ...this.lazyParams })
        },
    },
    beforeCreate() {
        this.helper = new Helper()
    }
}
</script>